import { render } from "./SurveyStatistics.vue?vue&type=template&id=2b1f871a"
import script from "./SurveyStatistics.vue?vue&type=script&lang=js"
export * from "./SurveyStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__